import { useCallback, useEffect, useState } from "react";
import { getInstitutionDashboardData } from "../../../../api/institutionApi";

export function useInstitutionWalletDashboard(institutionId) {
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState("");

  const loadDashboard = useCallback(async () => {
    if (!institutionId) return;

    try {
      setDashboardLoading(true);
      setDashboardError("");

      const response = await getInstitutionDashboardData(institutionId);
      setDashboardData(response || null);
    } catch (err) {
      console.error("Failed to load institution wallet dashboard", err);
      setDashboardError("Долоо хоногийн dashboard ачааллахад алдаа гарлаа");
    } finally {
      setDashboardLoading(false);
    }
  }, [institutionId]);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  return {
    dashboardData,
    dashboardLoading,
    dashboardError,
    loadDashboard,
  };
}